import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import GuestPassActions from 'flux/actions/GuestPassActions';
import RealTimeActions from 'flux/actions/RealTimeActions';

export default Reflux.createStore({
  mixins: [BaseMixin],

  init() {
    this.listenTo(
      GuestPassActions.toggleGuestPass.completed,
      'onToggleGuestPassCompleted',
    );
  },

  onToggleGuestPassCompleted(show) {
    let change = { disableGuestPass: show.disableGuestPass };
    RealTimeActions.showMutatedRealTime(show._id, change);
  },
});
